import React, { useState } from "react";
import { bookingService } from "../../services/bookingService";
import { toast } from "react-toastify";
const Coupon = ({ tourId, discount, setDiscount }) => {
  const [discountCode, setDiscountCode] = useState("");
  const [error, setError] = useState("");

  const handleApplyCoupon = async () => {
    if (!discountCode.trim()) {
      setError("Vui lòng nhập mã giảm giá.");
      setDiscount(null);
      return;
    }

    try {
      const response = await bookingService.getDiscountByCode(
        discountCode,
        tourId
      );

      if (!response.isActive) {
        setError("Mã giảm giá đã quá hạn sử dụng.");
        setDiscount(null);
        return;
      }

      setDiscount(response);
      setError("");
    } catch (err) {
      setError(err || "Không áp dụng được giảm giá.");
      setDiscount(null);
    }
  };

  const handleRemoveCoupon = () => {
    setDiscount(null);
    setDiscountCode("");
  };

  const handleCloseError = () => {
    setError("");
  };
  return (
    <div className="card coupoun">
      <div className="card-header">
        <h5>Phiếu giảm giá</h5>
      </div>
      <div className="card-body">
        <div>
          <div className="d-flex align-items-center mb-3">
            <input
              type="text"
              className="form-control me-2"
              placeholder="Mã giảm giá"
              value={discountCode}
              onChange={(e) => setDiscountCode(e.target.value)}
            />
            <button
              className="btn btn-primary flex-shrink-0"
              onClick={handleApplyCoupon}
            >
              Áp dụng phiếu giảm giá
            </button>
          </div>
          <div>
            {discount && (
              <div className="coupoun-list mb-3">
                <p className="text-center">
                  Mã giảm giá{" "}
                  <span className="text-gray-9">
                    {" "}
                    {discount.discountCode} ({discount.discountPercentage}%){" "}
                  </span>{" "}
                  đã được áp dụng thành công{" "}
                  <a
                    href="#"
                    className=" ms-2 text-primary text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemoveCoupon();
                    }}
                  >
                    LOẠI BỎ
                  </a>{" "}
                </p>
              </div>
            )}

            {error && (
              <div className="coupoun-list-two">
                <p className="text-center">
                  {error}{" "}
                  <a
                    href="#"
                    className=" ms-2 text-primary text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCloseError();
                    }}
                  >
                    Đóng
                  </a>{" "}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coupon;
